define('models/AppModel',[
    'underscore',
    'jquery',
    'ObjectModel',
    'router',
    'hooks',
    'prototypes/WebSocket',
    'LogExecutionTime',
    'TraceExecutionTime',
    'TagCommander',
    'site_vars',
    'UrlFactory',
    'Geolocation',
    'string',
    'sprintf',
    'moment',
], function (
    _,
    $,
    ObjectModel,
    router,
    hooks,
    WebSocket,
    LogExecutionTime,
    TraceExecutionTime,
    TagCommander,
    site_vars,
    UrlFactory,
    Geolocation,
    S,
    sprintf,
    moment
) {
    //
    // App Model
    //

    var app, // singleton reference
        ErrorModel, // ref to ErrorModel
        $window = $(window),
        $body = $('body'),
        $htmlBody = $('html, body'),
        fallbackTest = /^fallback_.+/,
        initialScrollTop = 0;

    function SetupScroll(e) {
        initialScrollTop = $window.scrollTop();
        if (app) {
            app.set('scrollTop', initialScrollTop);
        }
    }
    function onScroll(e) {
        if (app) {
            app.trigger('scroll', e);
        }
    }

    $window.on('scroll', SetupScroll);
    SetupScroll();

    var AppModel = ObjectModel.extend({
        name: 'AppModel',
        $window: $window,
        $body: $body,
        $htmlBody: $htmlBody,
        defaults: {
            scrollLocked: false,
            scrollTop: initialScrollTop,
            winW: $window.width(),
            winH: $window.height(),
            deviceType: false,
        },
        initialize: function () {
            app = this;
            app.initApp();
            UrlFactory.setup(app, router);
        },
        setupErrorModel: function (e) {
            ErrorModel = e;
        },
        setupObjects: function (objects) {
            LogExecutionTime('app setupObjects');
            app.set(objects);

            var devaticsCategory = app.getCategoryDevatics();
            if (devaticsCategory) {
                devaticsCategory.setupDevatics();
            }
            //
            if (Geolocation.cookiePosition) {
                app.set(Geolocation.cookiePosition);
            }

            // devatics global scope function dvt_setup
            window.dvt_setup = function () {
                if (devaticsCategory) {
                    devaticsCategory.fetchDevatics();
                }
                app.trigger('dvt_setup', 'dvt_setup');
            };

            app.getCurrency().modernizr();

            // Hook endScriptsComplete non utilisé
            // hooks.registerHook('endScriptsComplete',function(){});

            // category favorites
            if (app.getCategoryFavorites()) {
                app.getCategoryFavorites().setupFavorites();
            }

            //
            app.getPaymentGroups().setup();

            app.getStoresInt().setupInternational();

            var cart = app.getCart(),
                store = cart.getStore(),
                addresses = app.getAddresses(),
                messages = app.getMessages(),
                customer = app.getCustomer();

            // global cart reference
            window.cart = cart;

            customer.on('login logout', function (e) {
                // quand on change d'utilisateur, on recharge toutes les adresses
                addresses.reset();
                if (customer.isLogged()) {
                    // si l'utilisateur est identifié, on charge ses adresses
                    addresses.remoteFetch();
                }
            });

            app.on('X-Customer-authenticated', function (state) {
                var isLogged = customer.isLogged(),
                    requireFetch = state === (isLogged ? 'no' : 'yes');
                if (requireFetch && !customer.isRemoteFetching) {
                    if (isLogged) {
                        customer.clear();
                        customer.trigger('externalLogout');
                    } else {
                        customer.remoteFetch();
                    }
                }
            });

            customer.on('externalLogout', function () {
                app.confirm(
                    {
                        title: app.t('Attention', 'UI'),
                        subtitle: app.t(
                            'Vous avez été déconnecté',
                            'Authentification'
                        ),
                        cancel: app.t('Ok', 'UI'),
                        validation: app.t('Me reconnecter', 'Authentification'),
                    },
                    function (confirm) {
                        if (confirm) {
                            app.go('authentification');
                        }
                    }
                );
            });

            app.on('X-Store-closed', function (state) {
                cart.set('store_closed', state === 'yes');
            });

            TagCommander.setup(app);

            function SetupCart() {
                LogExecutionTime('Setup Cart', 6);
                cart.setup(function () {
                    // cart setup callback

                    if (cart) {
                        LogExecutionTime(
                            'Message listen Cart deliveryUpdate',
                            6
                        );
                        // lors des changements de mode de livraison on recharge les messages
                        cart.on('deliveryUpdate', function () {
                            if (messages) messages.fetchAndReset();
                            app.getProducts().clearSidedishes();
                        });
                    }

                    $window.off('scroll', onScroll);
                    $window.on('scroll', SetupScroll);
                    try {
                        hooks.setup(app);
                    } catch (err) {
                        app.alert();
                    }
                    LogExecutionTime('cart setup callback');
                    if (
                        app.c('_ENV_') != 'prod' ||
                        app.c('_TRACE_EXECUTION_TIME_', false)
                    )
                        TraceExecutionTime();
                });
            }

            // async event
            if (store) {
                store.once('sync', SetupCart);
                store.fetch();
            } else {
                SetupCart();
            }
        },

        getShopName: function () {
            return app.c('_SHOP_NAME_');
        },
        getIsoLang: function () {
            return site_vars.iso_lang.toLowerCase();
        },
        getCountryCode: function () {
            return site_vars.country_code;
        },
        getIngredients: function () {
            return app.get('ingredient');
        },
        getIngredient: function (id_ingredient) {
            return app.getIngredients().get(id_ingredient);
        },

        getTags: function () {
            return app.get('tag');
        },
        getTag: function (id_tag) {
            return app.getTags().findWhere(id_tag);
        },

        getAddresses: function (filter) {
            var addresses = app.get('address');
            return addresses;
        },
        getAddress: function (id_address, includeDeleted) {
            if (_.isUndefined(id_address) || id_address == '') return;
            var id_address = id_address.toString(),
                params = { id_address: id_address };
            if (includeDeleted !== true) {
                params.deleted = 0;
            }
            var addresses = app.getAddresses(),
                address = addresses.findWhere(params);
            // gestion du fallback address non google place_id
            if (!address && fallbackTest.test(id_address)) {
                address = addresses.findWhere({ fallback: id_address });
                if (!address) {
                    var deliveryAddressData = app.getCart().getDeliveryAddressData();
                    var deliveryOptions = app.getCart().getDeliveryOptions();
                    address = new addresses.model(
                        _(deliveryOptions).defaults(params, deliveryAddressData)
                    );
                    //address.localFetch();
                    addresses.add(address);
                }
            }
            return address;
        },
        getAddressSeparator: function (noSpace) {
            var separator = app.c('_GOOGLE_ADDRESS_SEPARATOR_', ',');
            if (!/ $/.test(separator)) {
                // on force l'espace après la virgule si il n'existe pas
                separator += noSpace ? '' : ' ';
            }
            return separator;
        },
        getAllergenGroups: function () {
            return app.get('allergengroup');
        },
        getFiltersChecked: function () {
            return (
                app.getTags().getCheckedCount() +
                app.getAllergenGroups().getCheckedCount()
            );
        },
        getBanner: function (id_banner) {
            var banners = app.getBanners();
            return banners ? banners.get(id_banner) : false;
        },
        getBanners: function () {
            return app.get('banner');
        },
        getBenefit: function (id_benefit) {
            var benefits = app.getBenefits();
            return benefits ? benefits.get(id_benefit) : false;
        },
        getBenefits: function () {
            return app.get('benefits');
        },
        getCarriers: function () {
            return app.get('carrier');
        },
        getCategory: function (id_category) {
            return app.getCategories().get(id_category);
        },
        getCategories: function () {
            return app.get('category');
        },
        //
        // attention la notion de slug n'existe pas vraiment sur le model category
        // elle correspond à un identifiant géré via Configuration
        //
        getCategoryBySlug: function (slug) {
            var configurationName = sprintf
                .vsprintf('_%s_CATEGORY_ID_', [slug])
                .toUpperCase();
            return app.getCategory(app.c(configurationName));
        },
        getCategoryDevatics: function () {
            try {
                return app.getCategoryBySlug('bestseller');
            } catch (err) {
                return;
            }
        },
        getCategoryFavorites: function () {
            try {
                if (app.getCustomer().isLogged() != true) return false;
                return app.getCategoryBySlug('favorites');
            } catch (err) {
                return;
            }
        },
        getConfigurations: function () {
            return app.get('configuration');
        },
        getCountry: function (id_country) {
            // raccourci pour obtenir le pays du site, ne passer aucun id_country
            if (!id_country) id_country = app.c('_ID_COUNTRY_');
            // pour obtenir un pays à partir de son identifiant
            return app.get('country').get(id_country);
        },
        getCountryByIsoCode: function (country_code) {
            return app.get('country').find(function (country) {
                return (
                    country.get('iso_code').toLowerCase() ==
                    country_code.toLowerCase()
                );
            });
        },
        getCurrencies: function () {
            return app.get('currency');
        },
        getCurrency: function (id_currency) {
            // default id_currency
            if (!id_currency) {
                id_currency = app.c('_ID_CURRENCY_DEFAULT_');
            }
            return app.getCurrencies().get(id_currency);
        },
        getGenders: function () {
            return app.get('gender');
        },
        getInstagramCategory: function (id_insta_display_category) {
            return app.get('instagramCategory').get(id_insta_display_category);
        },
        getInstagramPost: function (id_insta_post) {
            return app.get('instagramPost').get(id_insta_post);
        },
        getLanguages: function () {
            return app.get('language');
        },
        getMacarons: function () {
            return app.get('macaron');
        },
        getMacaron: function (id_macaron) {
            return app.getMacarons().get(id_macaron);
        },
        getPictureTypes: function () {
            return app.get('pictureType');
        },
        getProduct: function (id_product) {
            return app.getProducts().get(id_product);
        },
        getProducts: function () {
            return app.get('product');
        },
        getPostcodes: function () {
            return app.get('postcode');
        },
        getPostcode: function (id_postcode) {
            return app.getPostcodes().get(id_postcode);
        },
        getPostcodeByLinkSEO: function (link_rewrite_seo) {
            return app
                .getPostcodes()
                .findWhere({ link_rewrite_seo: link_rewrite_seo });
        },
        getPostcodeByValue: function (value) {
            if (!_.isUndefined(value)) {
                value = value.toUpperCase();
            }

            var _MOD_POSTCODE_REGEX_ = app.c('_MOD_POSTCODE_REGEX_', false),
                _MOD_POSTCODE_ = app.c('_MOD_POSTCODE_'),
                err = 'invalid _MOD_POSTCODE_REGEX_',
                postcode = value,
                postcodes = app.getPostcodes();

            //  postcode = postcode.toUpperCase();
            if (_MOD_POSTCODE_REGEX_) {
                try {
                    var postcodeRegExp = eval(_MOD_POSTCODE_REGEX_),
                        exec;
                    if (postcodeRegExp instanceof RegExp) {
                        exec = postcodeRegExp.exec(value);
                    } else {
                        throw new Error(err);
                    }
                } catch (err) {
                    app.error(err, _MOD_POSTCODE_REGEX_);
                }
                switch (_MOD_POSTCODE_) {
                    case 'with_suffix':
                        if (exec) {
                            // converti la saisie via l’expression régulière
                            postcode = exec[1];
                            if (postcode === '') {
                                // cas spécial du luxembourg ou il y a un seul code postal avec des quartiers
                                // il suffit de configurer une expression régulière permissive
                                return postcodes.first();
                            }
                        } else {
                            // si le code postal ne match pas
                            // avec la syntaxe de l'expression régulière
                            // on ne renvoie pas de résultat
                            return;
                        }
                        break;
                }
            }
            return postcodes.findWhere({ postcodeUpperCase: postcode });
        },
        getPostcodeByDistrict: function (id_district) {
            // reverse district to postcode
            return app.getPostcodes().findWhere(function (postcode) {
                return postcode.getDistrict(id_district);
            });
        },
        getDistrict: function (id_district) {
            // District is not implemented as a Backbone Model, raw JS Object is returned
            return app.getPostcodes().getDistrict(id_district);
        },
        getStores: function () {
            return app.get('store');
        },
        getStoresInt: function () {
            return app.get('storeInt');
        },
        getStore: function (id_store) {
            var stores = app.getStores();
            if (!id_store || !stores) return;
            return stores.get(id_store.toString());
        },
        getStoreServices: function () {
            return app.get('storeService');
        },
        getTranslations: function () {
            return app.get('translation');
        },
        getHybridRouting: function() {
            return app.get('hybridRouting');
        },
        getCartStore: function () {
            return app.getCart().getStore();
        },
        getPaymentMethods: function () {
            return app.get('paymentMethod');
        },
        getPaymentGroups: function () {
            return app.get('paymentGroup');
        },
        getPaymentGroup: function (id_payment_group) {
            return app.getPaymentGroups().get(id_payment_group + '');
        },
        getPaymentBrands: function () {
            return app.get('paymentBrand');
        },
        getPaymentBrand: function (id_payment_method_brand) {
            return app.getPaymentBrands().get(id_payment_method_brand + '');
        },
        getPaymentMode: function (id_payment_mode) {
            return app.getPaymentModes().get(id_payment_mode);
        },
        getPaymentModes: function (id_payment_mode) {
            return app.get('paymentMode');
        },
        getPaymentMethod: function (id_payment_method) {
            return app.getPaymentMethods().get(id_payment_method);
        },
        getCustomer: function () {
            return app.get('customer');
        },
        getCart: function () {
            return app.get('cart');
        },
        getCartProduct: function (id_cart_product) {
            return app.getCart().getProduct(id_cart_product);
        },
        getMessages: function () {
            return app.get('message');
        },
        getMessage: function (location, options) {
            var messages =
                !!options && options.messages
                    ? options.messages
                    : app.getMessages();
            return messages.getByLocation(location, options);
        },

        getPictureUrl: function (id_picture, model, suffix, format, rewrite) {
            var pictureType = suffix;
            if (suffix !== 'origin' && suffix !== 'noscale') {
                // sauf pour les images origin et noscale (des formats spéciaux, statiques, non redimensionnés)
                pictureType = app.getPictureTypes().getType(suffix, format);
                if (!pictureType) {
                    app.error(
                        'Unknown pictureType : ' + suffix + ' / ' + format
                    );
                    return;
                }
            }
            return router.getPictureUrl(
                id_picture,
                model,
                pictureType,
                rewrite,
                format
            );
        },
        getWidgetInstance: function (id_widget_instance) {
            var widgetInstanceCollection = app.get('widgetInstance');
            if (!widgetInstanceCollection) {
                return false;
            }
            var widgetInstance =
                widgetInstanceCollection.get(id_widget_instance);
            if (!widgetInstance) {
                // setup Widget circular dependencies
                widgetInstance = widgetInstanceCollection.findWhere({
                    id_widget_instance: id_widget_instance,
                });
            }
            return widgetInstance;
        },
        isSalesModeActive: function () {
            return this.c('_ENABLE_SALES_MODE_', 1);
        },
        isProductModeActive: function () {
            return this.c('_ENABLE_PRODUCT_MODE_', 1);
        },
        isReorderEnable: function () {
            return +app.c('_ENABLE_REORDER_', 1) === 1;
        },
        isCheckoutV2: function () {
            return app.c('_PAYMENT_V2_DESKTOP_', '1') === '1';
        },
        getWidgetGroup: function (identifiant) {
            var groups = app.getWidgetGroups(),
                group = groups.findWhere({ indentifiant: identifiant });
            return group;
        },
        getWidgetGroups: function (identifiant) {
            return app.get('widgetGroup');
        },
        getWidgetCollectionFromGroup: function (identifiant) {
            var group = this.getWidgetGroup(identifiant);

            return group.getContextualCollection();
        },
        getWidgetCollection: function (id_widget_collection) {
            return app.get('widgetCollection').get(id_widget_collection);
        },

        getNews: function (id_news) {
            var news = app.get('news');
            if (news) {
                return news.get(id_news.toString());
            }
        },
        getNewsFlag: function (id_news_flag) {
            var newsFlag = app.get('newsFlag');
            if (id_news_flag && newsFlag) {
                return newsFlag.get(id_news_flag.toString());
            }
        },
        getMenuBySlug: function (identifiant) {
            return app.get('menu').findWhere({ identifiant: identifiant });
        },
        getMenu: function (id_menu) {
            return app.get('menu').get(id_menu);
        },

        //
        getThemeUrl: function () {
            return site_vars.theme_url;
        },

        // translate shortcut
        t: function (value, context, parameters) {
            return app.getTranslations().translate(value, context, parameters);
        },

        // configuration get value shortcut
        c: function (key, defaultValue) {
            var result = app.getConfigurations().getValue(key, defaultValue);
            if (result == key && defaultValue) {
                return defaultValue;
            }
            return result;
        },

        htmlentities: function (str) {
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        },

        deviceType: function () {
            return app.get('deviceType');
        },
        isMobile: function () {
            return app.deviceType() == 'mobile';
        },
        isDesktop: function () {
            return app.deviceType() == 'desktop';
        },
        hooksStarted: function () {
            router.setup(app);
            WebSocket.setup(app);
            LogExecutionTime('router.setup(app)');
            hooks.execHook('beforeHooksStarted', app);
            app.trigger('hooksStarted', app);
            LogExecutionTime('hooksStarted');
        },
        scrollTop: function (scrollTop, duration) {
            //
            // permet de gérer le scroll général, avec ou sans animation
            //
            app.set('scrollTop', scrollTop);
            if (duration > 0) {
                // si duration est défini et supérieur à zero, on l'utilise pour faire une animation jQuery
                $htmlBody.animate({ scrollTop: scrollTop }, duration);
            } else {
                $htmlBody.scrollTop(scrollTop);
            }
        },
        isoLang: function () {
            return site_vars.iso_lang.toLowerCase();
        },
        // isWebView:function(){
        //     // renvoyé par la webview d'une app
        //     return site_vars.webapps === true;
        // },
        isCheckoutMapEnable: function () {
            return app.c('_CHECKOUT_MAP_ENABLE_', 0) === '1';
        },
        isRGPD: function () {
            return app.c('_RGPD_ENABLE_CHECK_', 0) === '1';
        },
        //
        isListingAllCategories: function () {
            return app.get('isListingAllCategories');
        },
        isNowLunch: function (datetime) {
            if (!datetime) datetime = new Date();
            var _LUNCH_DINER_SERVICE_THRESHOLD_TIME_ = app.c(
                    '_LUNCH_DINER_SERVICE_THRESHOLD_TIME_',
                    '16:00:00'
                ),
                parts = _(_LUNCH_DINER_SERVICE_THRESHOLD_TIME_.split(':')).map(
                    function (part) {
                        return parseInt(part);
                    }
                ),
                hours = parts[0] || 0,
                minutes = parts[1] || 0,
                m = moment(datetime),
                mh = m.hours();
            return mh < hours || (mh <= hours && m.minutes() <= minutes);
        },
        hasNotCustomerPrimaryAddress: function () {
            return _(app.getCustomer().getPrimaryAddress()).isUndefined();
        },
        error: function (message, debug) {
            var errorModel;
            try {
                var trace = ErrorModel.getTrace(message);
                errorModel = new ErrorModel(trace, debug);
            } catch (err) {
            }
            return errorModel;
        },
        blockError: function ($el) {
            // affiche un message d'erreur dans l’el jQuery
            try {
                var errorTitle = app.t('Désolé', 'UI'),
                    errorMessage =
                        app.t(
                            'Ce bloc n’a pu être affiché en raison d’une erreur.',
                            'Error'
                        ) +
                        '<br />' +
                        app.t(
                            'N’hésitez pas à contacter le service client.',
                            'Error'
                        );
                $el.html(
                    '<div class="alert alert-danger"><strong>' +
                        errorTitle +
                        ' :</strong> ' +
                        errorMessage +
                        '</div>'
                );
                TagCommander.tc_err($el.get(0), errorTitle, errorMessage);
            } catch (err) {
            }
        },
        tc_error: function (el, title, message) {
            TagCommander.tc_err(el, title, message);
        },
        notify: function (type, options, callback) {
            app.trigger(type + 'Notice', options, callback);
        },
        alert: function (options, callback) {
            if (_.isUndefined(options)) {
                var title = 'Setup Error',
                    subtitle = 'please contact support service.',
                    errorModel;
                try {
                    errorModel = app.error(); //
                } catch (err) {
                }
                try {
                    title = app.t('Oups…', 'Error');
                    subtitle = app.t(
                        'Une erreur inconnue semble être apparue.',
                        'Error'
                    );
                    if (errorModel && site_vars.env != 'prod') {
                        subtitle +=
                            '<pre class="alert alert-danger">' +
                            errorModel.get('stack') +
                            '</pre>';
                    }
                } catch (err) {}
                options = {
                    title: title,
                    subtitle: subtitle,
                };
            }
            app.notify('alert', options, callback);
        },
        confirm: function (options, callback) {
            app.notify('confirm', options, callback);
        },
        prompt: function (options, callback) {
            app.notify('prompt', options, callback);
        },
        bottomNotice: function (options) {
            app.notify('bottom', options);
        },
        banNotice: function (options) {
            app.notify('ban', options);
        },

        displayModal: function (view) {
            app.trigger('displayModal', view);
        },

        //
        go: function (target, options, reload) {
            var route = '';
            switch (target) {
                case 'product':
                    if (options.product) {
                        route = UrlFactory.getRoute(
                            'product',
                            options.product.getUrlOptions(),
                            true,
                            false
                        );
                        break;
                    }
                case 'listing':
                    route = UrlFactory.getRoute(
                        'allCategories',
                        {},
                        true,
                        false
                    );
                    break;
                case 'stores':
                    app.set('storeLocatorSearch', '');
                    route = UrlFactory.getRoute(target, {}, true, false);
                    break;
                case 'category':
                case 'home':
                case 'authentification':
                case 'accountDashboard':
                case 'accountOrders':
                case 'cart':
                case 'checkoutOpc':
                case 'supportCenter':
                case 'supportCenterResource':
                case 'supportCenterSearch':
                case 'storeLocatorPosition':
                case 'storeLocatorBounds':
                    route = UrlFactory.getRoute(
                        target,
                        _.defaults({}, options),
                        true,
                        false
                    );
                    break;
                case 'storeLocatorSearch':
                    // slugify la recherche
                    var search = S(options.search).slugify().s;
                    // enregistre la valeur de recherche non formatée au niveau app
                    app.set('storeLocatorSearch', options.search);
                    route = UrlFactory.getRoute(
                        target,
                        { search: search },
                        true,
                        false
                    );
                    break;
                default:
                    break;
            }
            router.go(route || '', reload);
        },
        //
        alertReCaptcha: function (message) {
            var opt = {
                title: app.t('Échec vérification de sécurité', 'UI'),
                subtitle: message,
                cancel: app.t('Réessayer', 'UI'),
                validation: app.t('Contacter le support', 'SupportCenter'),
            };
            app.confirm(opt, function (success) {
                if (success) {
                    app.go('supportCenter');
                }
            });
        },

        getAvisVerifieComments: function () {
            var comments = app.get('avisverifie');

            if (!comments) {
                return _([]);
            }
            _(comments.models).each(function (e) {
                if (e) {
                    e.set('store', app.getStore(e.get('id_store')));

                    /* var name = !app.getStore(e.get('firstname')) || app.getStore(e.get('firstname')) === 'Anonymous'
                        ? app.t('Anonyme', 'avisverifie') : app.getStore(e.get('firstname'))
                    e.set('firstname', name) */

                    if (!e.get('firstname')) {
                        e.set('firstname', app.t('Anonyme', 'avisverifie'));
                    }

                    // format order_date
                    var date = e.get('order_date');
                    if (date && !isNaN(Date.parse(date))) {
                        date = moment(date).format('DD/MM/YYYY');
                    }
                    e.set('order_date', date);
                }
            });
            return app.get('avisverifie');
        },
        getAvisVerifie: function () {
            return app.c('_AVIS_VERIFIE_AVG_AVIS_');
        },

        getBenefits: function () {
            return this.get('storeBenefit');
        },
        getSearchableBenefits: function () {
            return this.getBenefits()
                ? this.getBenefits().getSearchable()
                : _({});
        },
        hasGeolocation: function () {
            return !!app.get('latLng');
        },
        // request Native HTML5 Geolocation API
        requestGeolocation: function () {
            app.trigger('geolocation_pending');
            Geolocation(function (err, result) {
                // success
                var position = result;
                if (err) {
                    // test only
                    //if(err && err.code == 1 && err.constructor.name == 'PositionError'){
                    //    position ={
                    //        latitude:48.878135,
                    //        longitude:2.320819
                    //    };
                    //}
                    app.trigger('geolocation_error');
                    return;
                }
                try {
                    position.latLng = new google.maps.LatLng(
                        position.latitude,
                        position.longitude
                    );
                } catch (err) {
                    // TODO
                    app.trigger('geolocation_error');
                }
                app.set(position);
                app.trigger('geolocation', position);
            });
        },
        hasPaymentModesStorable: function () {
            // permet de savoir si on peut enregistrer des cartes Ogone ou Edenred
            var paymentModes = app.getPaymentModes(),
                ogonePaymentMode = paymentModes.findWhere({
                    provider: 'OgoneProvider',
                }),
                endenredPaymentMode = paymentModes.findWhere({
                    provider: 'EdenredProvider',
                });
            return (
                !!endenredPaymentMode ||
                (!!ogonePaymentMode &&
                    !!ogonePaymentMode
                        .getBrands()
                        .findWhere({ directlink: true }))
            );
        },

        // met à jour les données des dimensions de fenêtre et de document
        updateDocumentDimensions: function () {
            app.set({
                winW: $window.width(),
                winH: $window.height(),
                docW: $body.outerWidth(),
                docH: $body.outerHeight(),
            });
            app.trigger('updateDocumentDimensions', app);
        },
        isFacebookDisabled: function () {
            return !app
                .getConfigurations()
                .getValue('_ENABLED_FACEBOOK_', false);
        },
        isDeliveryOptionsRequired: function () {
            return app.c('_DELIVERY_OPTIONS_REQUIRED_', 0) == 1;
        },
        warnBaguettesReutilisables: function(onModal) {
            var _BAGUETTES_REUTILISABLES_ = app.c('_BAGUETTES_REUTILISABLES_',0);
            var baguettesReutilisablesProduct = app.getProduct(_BAGUETTES_REUTILISABLES_);
            var _BAGUETTES_REUTILISABLES_WARN_ = app.c(onModal?'_BAGUETTES_REUTILISABLES_WARN_MODAL_':'_BAGUETTES_REUTILISABLES_WARN_',0) == 1;
            return baguettesReutilisablesProduct && _BAGUETTES_REUTILISABLES_WARN_ && baguettesReutilisablesProduct.isBuyableInContext();
        },
        checkoutAddressDataCheck: function () {
            return app.c('_CHECKOUT_ADDRESS_DATA_CHECK_', 0) == 1;
        },
        getDeeplink: function (url) {
            var universalLink = app.get('universalLink');
            return !!universalLink ? universalLink.getDeeplink(url) : false;
        },
        useHomeOtherCountry: function () {
            return app.c('_HOME_DISPLAY_OTHER_CONTRY',0) == 1;
        },
        useHomePageWithoutLangPrefix: function () {
            return !app.useHomeOtherCountry() && app.getLanguages().getDefault().get('iso_code') === site_vars.iso_lang.toUpperCase();
        },
        getOptinMentions: function () {
            return app.c(
                '_OPTIN_MENTIONS_TEXT_',
                'j’ai pris connaissance des CGV'
            );
        },
    });

    return AppModel;
});

